import React, { Component } from 'react';
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact';
import BasicLabel from '../../../components/SharedComponents/BasicLabel/BasicLabel';
import './Reports.scss';
import Production from './Production';
import { saveAs } from 'file-saver';
import ReportButton from './ReportButton';
import { withUserContext } from "../../../../contexts/UserContext";
import { s2ab, genReportName } from '../../Helper';
import SelectField from '../../../components/SharedComponents/SelectField/SelectField';
import CasterService from '../../../../services/service';
import * as Constants from '../../../../constants/constants';

class ContractStatusFc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectProduction: "",
            postInitiated: false,
            performerOptions: [],
            dealDateOptions: [],
            performer_id: null,
            performer_label: null,
            deal_date: null,
            deal_date_id: null,
            disableDeals: true,
        }
    }

    getPerformerOptions = (production_id) => {
        CasterService.getData(Constants.CasterServiceBaseUrl + '/productionSeasonEpisodePerformers?productionId=' + production_id, this.props?.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let filteredList = response.data?.map(item => ({ value: item.pse_performer_id, label: item.performer_role_name }));
                this.setState({
                    performerOptions: filteredList.filter((value, index, arr) =>
                    index === arr.findIndex((item) => (
                        item.value === value.value 
                    ))
                ),
                })
            },
                (err) => {
                    console.log("Error in fetching performer details", err)
                })
    }


    loadPerformerDeals = (id) => {
        CasterService.getData(Constants.CasterServiceBaseUrl + `/performerDeal?psePerformerId=${id}`, 1)
            .then(response => {
                let filteredList = response.data?.map(item => ({ value: item.pse_performer_deal_id, label: item.deal_date }));
                this.setState({ dealDateOptions: filteredList, disableDeals: false });
            },
                (err) => {
                    console.log("Error in fetching deal details", err)
                })
    }

    handleSubmitContractStatusFc = (docFlag = 0, excelFlag = 0) => {
        this.setState({ 
            postInitiated: true,
        });
        let { performer_id, deal_date, selectProduction, performer_label } = this.state;
        let production_id = selectProduction?.value;

        // if (this.props?.reportDownloadName === "ContractStatus") {
            if (!production_id) {
                return;
            }
        // } else if (this.props?.reportDownloadName === "DealWorksheet" || this.props?.reportDownloadName === "DealWorksheetScheduleF") {
        //     if (!production_id || !performer_id) {
        //         return;
        //     }
        // }

        let payload = {
            production_id,
            performer_id,
            //deal_date
        }
        if(this.props?.showDealDate) {
            payload.deal_date = deal_date
        }
        let obj = {
            reportName: this.props?.reportDownloadName,
            production: selectProduction?.label,
            season: "",
            episode: "",
            performer: performer_label,
        }
        let reportNameFinal = genReportName(obj)
        this.props.generateReport(this.props?.reportName, payload, reportNameFinal,docFlag, excelFlag)
        this.setState({postInitiated: false})
    }

    onChangeCallBack = (field, val) => {
        this.setState({
            [field]: val,
            postInitiated: false
        });
        if (field === 'selectProduction') {
            this.getPerformerOptions(val?.value);
        } else if (field === 'performer_id') {
            this.setState({
                performer_label: val.currentTarget.innerText,
                performer_id: val.target.value
            });
            this.loadPerformerDeals(val.target.value);
        } else if (field === 'deal_date_id') {
            this.setState({
                deal_date: val.currentTarget.innerText,
                deal_date_id: val.target.value
            });
        }
    }

    render() {
        return (
            <div>
                <MDBContainer className="reportContainer CastList">
                    <MDBRow>
                        <BasicLabel text={"Options"} />
                    </MDBRow>
                    <MDBRow>
                        <Production
                            productionReq={true}
                            postInitiated={this.state.postInitiated}
                            onChangeCallBack={this.onChangeCallBack}
                        />
                    </MDBRow>
                    <MDBRow className="searchSelectFc">
                        <SelectField
                            label={"Performer Name"}
                            placeHolderText={'-All Performers-'}
                            value={this.state.performer_id}
                            options={this.state.performerOptions || []}
                            // isMandatory={this.props?.reportDownloadName !== "ContractStatus" ? true : false}
                            // showMandatory={this.props?.reportDownloadName !== "ContractStatus" && this.state.postInitiated || false}
                            onChange={(e) => this.onChangeCallBack('performer_id', e)}
                        />
                    </MDBRow>
                    {this.props?.showDealDate && <MDBRow>
                        <SelectField
                            label={"Deal Date"}
                            disabled={this.state.disableDeals}
                            value={this.state.deal_date_id}
                            options={this.state.dealDateOptions || []}
                            isMandatory={this.props?.reportDownloadName !== "ContractStatus" ? true : false}
                            showMandatory={this.props?.reportDownloadName !== "ContractStatus" && this.state.postInitiated || false}
                            onChange={(e) => this.onChangeCallBack('deal_date_id', e)}
                        />
                    </MDBRow>}
                    <ReportButton
                        generateExcel={this.props?.reportName !== 'rptFcDealWorksheetScheduleF'}
                        generateDoc={true}
                        onClickGenratePdf={this.handleSubmitContractStatusFc}
                        handleClose={this.props?.handleClose}
                    />
                </MDBContainer>
            </div>
        );
    }
}

export default withUserContext(ContractStatusFc);